export default "__VITE_ASSET__B2S6wAJK__"